import React from 'react'
import { useEntityNavigate as useNavigate } from '../../../navigation/navigation'
import EmployeeAvatar from '../../../components/EmployeeAvatar'
import Icon from '../../../components/Icon'
import { ActionMenu, Breadcrumb, Button, SegmentedControl } from '../../../components/ui'

function EmployeeDetailHeader({
  employee,
  actualTeamOptions,
  teamOptions,
  selectedTeam,
  showTeamSegment,
  getSystemRoleLabel,
  onTeamChange,
  actionItems,
  teamDataUrl,
}) {
  const navigate = useNavigate()

  return (
    <>
      <Breadcrumb
        items={[
          { label: 'Главная', to: '/' },
          { label: 'Сотрудники', to: '/company/team' },
          { label: employee.full_name || 'Сотрудник' },
        ]}
        className="employee-detail-breadcrumbs"
      />

      <header className="employee-detail-header">
        <div className="employee-detail-header__identity">
          <EmployeeAvatar employee={employee} size="large" showStatus={false} />
          <div className="employee-header-info">
            <h1>{employee.full_name || 'Сотрудник'}</h1>
            <div className="employee-detail-subtitle">
              {actualTeamOptions.length > 0 ? actualTeamOptions.map((option) => option.label).join(' · ') : (employee.department || '-')}
            </div>
            <div className="employee-detail-sr-only" aria-label="Служебная информация сотрудника">
              <span>{getSystemRoleLabel(employee?.user?.role)}</span>
              {employee.departments?.length > 0
                ? employee.departments.map((dept, idx) => <span key={idx}>{dept}</span>)
                : <span>{employee.department || '-'}</span>}
            </div>
          </div>
        </div>
        <div className="employee-detail-header__right">
          {teamDataUrl ? (
            <Button
              type="button"
              variant="outline"
              className="employee-team-data-btn"
              title="Открыть аналогичный раздел по моей команде"
              onClick={() => navigate(teamDataUrl)}
            >
              <Icon name="users" size={16} aria-hidden />
              Посмотреть данные по команде
            </Button>
          ) : null}
          {showTeamSegment && (
            <div className="employee-detail-team-control">
              <span className="employee-detail-team-label">Команда</span>
              <SegmentedControl
                className="employee-detail-team-segment"
                size="sm"
                ariaLabel="Команда сотрудника"
                options={teamOptions}
                value={selectedTeam}
                onChange={onTeamChange}
              />
            </div>
          )}
          {actionItems?.length > 0 && (
            <div className="employee-header-actions">
              <ActionMenu items={actionItems} />
            </div>
          )}
        </div>
      </header>
    </>
  )
}

export default EmployeeDetailHeader
